export const CompanyStatusCopyWriting = {
  ER: {
    header: "Organization has already existed",
    subheader:
      "We’ve found existing organization attached to this email. Do you wish to onboard this organization?",
    infoLabel: ["Company name", "Registration no.", "Primary address"],
  },
  JS: {
    header: "Upgrade to employer account",
    subheader:
      "We’ve found existing adnexio Jobseeker account attached to this email. By proceeding, your account will be upgraded to employer account and all the data will be reset.",
    infoLabel: ["Name", "Email"],
  },
};
